<template>
  <!-- class="navbar navbar-light navbar-expand-lg p-front__navbar navbar-fixed-top"  -->
  <div id="main_bar_holder">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-horizontal-dash"
      mode="horizontal"
      :background-color="getTheme['$background-color']"
      :text-color="getTheme['$text-color']"
      :active-text-color="getTheme['$active-text-color']"
    >
      <div index="1" class="menu_pin_holder">
        <div class="left_header_components">
          <slot name="menupin"></slot>
          <el-switch
            v-model="activeModel"
            @change="toggleTheme"
            style="display: block; margin-left: 100px;"
            active-text="Dark"
            inactive-text="Light"
          ></el-switch>
        </div>
        <div class="notifications_right" @click="navigateToNotifications">
          <p v-if="notifications">{{ getNotificationsCount() }}</p>
          <div class="icon-box">
            <span class="material-icons">
              notifications
            </span>
          </div>
        </div>
      </div>
      <!-- <el-submenu placement="bottom-end" index="2" style="float: right;">
        <template slot="title" class="initial-avatar">
          <span
            class="iconfont iconfont-helpdesk-analytics"
          >{{ (this.getUserSession !== null) ? this.getUserSession.firstName[0] + ' ' + this.getUserSession.lastName[0] : '-' }}</span>
        </template>
        <el-menu-item
          index="2-1"
        >{{ (this.getUserSession !== null) ? this.getUserSession.firstName + ' ' + this.getUserSession.lastName : '' }}</el-menu-item>

         <el-menu-item index="2-2" @click="logout">Logout</el-menu-item>
      </el-submenu>-->
      <!-- <el-dropdown style="float: right; padding: 20px 30px; color: #000;">
        <span class="el-dropdown-link">
          <i class="el-icon-bell" style="font-size: 20px;"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>Action 1</el-dropdown-item>
          <el-dropdown-item divided>Action 2</el-dropdown-item>
          <el-dropdown-item divided>Action 3</el-dropdown-item>
          <el-dropdown-item disabled divided>Action 4</el-dropdown-item>
          <el-dropdown-item divided>Action 5</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>-->
    </el-menu>
    <!-- <slot name="menupin">
    </slot>
    <can not I='all' a='anon'>
      <div class="loggedIn_menu" id="user-menu-top">
        <b-button @click="logout" class="pull-right nav-item " variant="danger">
          Logout
        </b-button>
      </div>
    </can>
    <can I='all' a='anon'>
      <div class="collapse navbar-collapse show" id="navbar-collapse" style="background: none;">
        <form class="form-inline">
          <router-link class="nav-item btn-default btn  btn-rounded" style="margin: 5px;" to="/auth/login">Sign In</router-link>
          <router-link class="nav-item btn btn-info btn-rounded" style="margin: 5px;" to="/auth/register">Sign Up</router-link>
          <a class="nav-item btn btn-secondary btn-rounded"  style="margin: 5px;" href="https://arnergy.surge.sh/about.html">About</a>
        </form>
      </div>
    </can>-->
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";

import Vue from "vue";

import { Dropdown, DropdownMenu, DropdownItem, Switch } from "element-ui";
import router from "../router";

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);

export default {
  name: "main-header",
  data() {
    return {
      activeModel: false,
      activeIndex: "2",
      notifications: true
    };
  },
  computed: {
    ...mapGetters([
      "isHome",
      "getTheme",
      "getUserSession",
      "themeList",
      "getUserNotifications"
    ])
  },
  methods: {
    ...mapActions(["setAccess", "setUserSession", "setDrawerMode", "setTheme"]),
    toggleTheme(status) {
      // console.log(this.themeList[status?'dark':'light']);
      this.setTheme(this.themeList[status ? "dark" : "light"]);
    },
    logout() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.post("/users/logout", {})
        .then(response => {
          container.setUserSession(null);
          setTimeout(() => {
            // container.$router.push({ path: "/auth/login" });\
            window.location.reload();
          }, 300);
        })
        .catch(e => {
          container.setUserSession(null);
          setTimeout(() => {
            window.location.reload();
          }, 300);
        });
    },
    login() {
      this.$router.push({
        path: "/auth/login"
      });
    },
    navigateToNotifications() {
      router.push({ name: "notifications" });
    },
    getNotificationsCount() {
      if (!this.getUserNotifications) return 0;
      return this.getUserNotifications.filter(item => item.read != true).length;
    }
  },
  mounted() {
    // this.setUserSession(null)
  }
};
</script>

<style lang="scss" scoped>
#hamburger {
  font-size: 24px !important;
  padding-top: 13px;
}

#navbar-collapse,
#user-menu-top {
  position: absolute !important;
  top: 0 !important;
  right: 0;
  padding-top: 5px !important;
  padding-right: 15px !important;
}
.menu_pin_holder {
  height: 61px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  float: left;
  width: 78%;
}
.menu_pin_holder .left_header_components,
.menu_pin_holder .notifications_right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.notifications_right {
  position: relative;
  cursor: pointer;
}
.notifications_right .icon-box {
  height: fit-content;
}
.notifications_right > p {
  margin: 0;
  font-size: 10px;
  background: #ee6c52;
  border: 1px solid #ffffff;
  color: #ffffff;
  padding: 0rem 0.4rem;
  padding-top: 0.1rem;
  height: 17px;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  top: -0.1rem;
  left: -0.25rem;
}
.notifications_right span {
  color: rgb(26, 147, 202);
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue